import moment from "moment";

function formatMoney(val, currency, decimals, separator) {
    val = val || 0;
    currency = currency || '$';
    decimals = decimals || 2;
    separator = separator || ',';
    const numStr = val.toFixed(decimals);
    let newNumStr = currency;
    const dotindex = numStr.indexOf('.');
    const offset = (3 + dotindex) % 3;
    for (let i = 0; i < dotindex; i++) {
        if (i > 0 && i % 3 === offset)
            newNumStr += separator;
        newNumStr += numStr[i];
    }
    newNumStr += numStr.substring(dotindex);

    return newNumStr;
}

async function webRequestWrap(axiosRequest) {
    try {
        const response = await axiosRequest;
        return response.data;
    } catch (e) {
        if (e.isAxiosError) {
            if (e.response.status === 422) {
                throw {isCustomError: true, type: "validation", data: e.response.data};
            }

            throw {isCustomError: true, type: "web-request", data: e.response.data};
        }

        throw {isCustomError: true, type: "unknown", data: e};

    }
}

function computedStateProp(path, set) {
    return {
        get() {
            let mp = '';
            if (this.getModelPath())
                mp = this.getModelPath() + '.';
            return _.get(this.$store.state, mp + path);
        },
        set(value) {
            let mp = '';
            if (this.getModelPath())
                mp = this.getModelPath() + '.';
            this.$store.commit('set_model_value', {set, path: (mp + path), value})
        }
    }
}

function dateConvert(date, inputFormat = 'YYYY-MM-DD', outputFormat = 'MM/DD/YYYY', defaultVal = null) {
    const tryParse = moment(date, inputFormat);
    if (tryParse.isValid()) {
        return tryParse.format(outputFormat);
    } else {
        return defaultVal;
    }
}

export {
    formatMoney,
    webRequestWrap,
    computedStateProp,
    dateConvert
}
